import React, { Component } from 'react';
import Icon from '@xo-union/tk-component-icons';

const defaultProps = {
  source: 'static social bar',
  trackingData: {},
  title: '',
};

export default class SocialSharingWidgets extends Component {
  constructor(props) {
    super(props);

    this.socialShareTrackEvents = this.socialShareTrackEvents.bind(this);
  }

  socialShareTrackEvents = service => (e) => {
    const { trackingData, source } = this.props;
    analytics.track('Social Share', {
      platform: 'web',
      source: source,
      service: service,
      url: trackingData.url,
      title: trackingData.title,
      product: XO.metadata.application.name,
      page_data: XO.analytics.page_data || {}
    });
  }

  render() {
    const { trackingData, title } = this.props;
    let urlTitle = title.replace(/ /g, '+'),
        url = trackingData.url;
    
    return(
      <div className="xo-social-sharing">
        <a aria-label="share to facebook" target="_blank" className="icon-container icon-holster facebook" href={"https://www.facebook.com/sharer/sharer.php?u=" + url} onClick={this.socialShareTrackEvents('facebook')} rel="nofollow">
          <Icon className="icon icon-square-bg icon-social-facebook" name='social_facebook_logo' />
        </a>
        <a aria-label="share to pinterest" target="_blank" className="icon-container icon-holster pinterest" href= {"https://pinterest.com/pin/create/button?description=" + urlTitle + "&media=" + trackingData.image +  "&url=" + url} onClick={this.socialShareTrackEvents('pinterest')} rel="nofollow">
          <Icon className="icon icon-square-bg icon-social-pinterest" name='social_pinterest_logo' />
        </a>
        <a aria-label="share to twitter" target="_blank" className="icon-container icon-holster twitter" href={"https://twitter.com/intent/tweet?text=Check+out+" + urlTitle + "&url=" + url + "&via=theknot"} onClick={this.socialShareTrackEvents('twitter')} rel="nofollow">
          <Icon className="icon icon-square-bg icon-social-twitter" name='social_twitter_logo' />
        </a>
        <a aria-label="share to email" target="_blank" className="icon-container email" href={"mailto:?body=" + url + "&subject=From The Knot: " + title} onClick={this.socialShareTrackEvents('email')} rel="nofollow">
          <Icon className="icon icon-square-bg icon-social-email" name='email' />
        </a>
      </div>
    )
  }
}

SocialSharingWidgets.defaultProps = defaultProps;
